import { render } from "./DataImporter.vue?vue&type=template&id=6ed7e4b7&scoped=true"
import script from "./DataImporter.vue?vue&type=script&lang=js"
export * from "./DataImporter.vue?vue&type=script&lang=js"

import "./DataImporter.vue?vue&type=style&index=0&id=6ed7e4b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed7e4b7"],['__file',"src/views/Imports/DataImporter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ed7e4b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ed7e4b7', __exports__)) {
    api.reload('6ed7e4b7', __exports__)
  }
  
  module.hot.accept("./DataImporter.vue?vue&type=template&id=6ed7e4b7&scoped=true", () => {
    api.rerender('6ed7e4b7', render)
  })

}


export default __exports__